import React, { useContext, useEffect, useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Card,
  CardContent,
  Grid,
  Chip,
  Divider,
  CircularProgress,
  Alert,
  Button,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Snackbar,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { ContextSession } from "../../services/ContextSession";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";

const DEPARTAMENTO_CHOICES = [
  //   { value: '', label: 'NO SELECCIONADO' },
  { value: "Call Center", label: "Call Center" },
  { value: "Comunicaciones", label: "Comunicaciones" },
  {
    value: "Departamento de Cartera y Cobro",
    label: "Departamento de Cartera y Cobro",
  },
  {
    value: "Departamento de Control de Ingresos",
    label: "Departamento de Control de Ingresos",
  },
  {
    value: "Departamento de Relaciones Institucionales",
    label: "Departamento de Relaciones Institucionales",
  },
  { value: "Departamento Prestamos", label: "Departamento Prestamos" },
  {
    value: "División de Actuaría y Estadísticas",
    label: "División de Actuaría y Estadísticas",
  },
  { value: "División de Beneficios", label: "División de Beneficios" },
  { value: "División de Prestamos", label: "División de Prestamos" },
  { value: "División de Negocios", label: "División de Negocios" },
  {
    value: "División de Servicios Legales",
    label: "División de Servicios Legales",
  },
  {
    value: "División de Servicios Legales S.P.S",
    label: "División de Servicios Legales S.P.S",
  },
  { value: "Pensiones Especiales", label: "Pensiones Especiales" },
  { value: "Planilla de Jubilados", label: "Planilla de Jubilados" },
  { value: "Secretaría General", label: "Secretaría General" },
  {
    value: "Unidad de Auditoría Interna",
    label: "Unidad de Auditoría Interna",
  },
  { value: "Unidad de Operaciones", label: "Unidad de Operaciones" },
  {
    value: "Unidad de Riesgos y Cumplimiento",
    label: "Unidad de Riesgos y Cumplimiento",
  },
  {
    value: "Unidad de Servicios Sociales",
    label: "Unidad de Servicios Sociales",
  },
  {
    value: "Unidad Técnica de Desarrollo Institucional",
    label: "Unidad Técnica de Desarrollo Institucional",
  },
  {
    value: "Unidad Técnica de Informática",
    label: "Unidad Técnica de Informática",
  },
  {
    value: "Unidad Servicios Generales",
    label: "Unidad Servicios Generales",
  },
];

const SUPERVISOR_ALLOWED_DEPARTMENTS = [
  "Departamento de Control de Ingresos",
  "Departamento Prestamos",
];

const normalizeSupervisorValue = (value) =>
  value === true || value === 1 || String(value || "").trim() === "1";

const normalizeDepartmentValue = (value) => String(value || "").trim();

const resolveUserDni = (data = {}) =>
  String(data?.dni || data?.DNI || data?.identidad || "").trim();

const isSupervisorDepartment = (department) =>
  SUPERVISOR_ALLOWED_DEPARTMENTS.includes(
    normalizeDepartmentValue(department)
  );

const UserProfile = () => {
  const { session } = useContext(ContextSession);
  let sessi = useContext(ContextSession);
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [userAccess, setUserAccess] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const userID = sessi.getVariable("Users360Id");

  // Estados para modales y edición
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editUserModalOpen, setEditUserModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedAccess, setSelectedAccess] = useState(null);
  const [accessToDelete, setAccessToDelete] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [modules, setModules] = useState([]);
  const [roles, setRoles] = useState([]);
  const [oficinas, setOficinas] = useState([]);

  // Datos del formulario
  const [formData, setFormData] = useState({
    modulo: "",
    rol: "",
    usuario_registro: "",
  });

  // Datos del formulario de usuario
  const [userFormData, setUserFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    username: "",
    departamento: "",
    is_active: false,
    supervisor: false,
    dni: "",
  });

  useEffect(() => {
    fetchUserData();
    fetchUserAccess();
    fetchModules();
    fetchOficinas();
  }, []);

  const fetchOficinas = async () => {
    try {
      const response = await fetch(
        //"http://127.0.0.1:8000/api/Access/modules/list/",
        "https://bei360.injupemp.gob.hn:8444/api/Oficinas/Consultar/",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
        }
      );

      if (response.status === 401) {
        const result = await response.json();
        if (result.code === "token_not_valid") {
          // Limpiar sesión y redirigir
          sessi.clearSession();
          navigate("/");
          return [];
        }
      }
      const data = await response.json();
      setOficinas(data);
    } catch (error) {
      console.error("Error fetching oficinas:", error);
    }
  };

  const fetchModules = async () => {
    try {
      const response = await fetch(
        //"http://127.0.0.1:8000/api/Access/modules/list/",
        "https://bei360.injupemp.gob.hn:8444/api/Access/modules/list/",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
        }
      );

      if (response.status === 401) {
        const result = await response.json();
        if (result.code === "token_not_valid") {
          // Limpiar sesión y redirigir
          sessi.clearSession();
          navigate("/");
          return [];
        }
      }
      const data = await response.json();
      setModules(data);
    } catch (error) {
      console.error("Error fetching modules:", error);
    }
  };

  const fetchRoles = async (moduleId) => {
    try {
      const response = await fetch(
        //`http://127.0.0.1:8000/api/Access/roles/list/?ModuleId=${moduleId}`,
        `https://bei360.injupemp.gob.hn:8444/api/Access/roles/list/?ModuleId=${moduleId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
        }
      );

      if (response.status === 401) {
        const result = await response.json();
        if (result.code === "token_not_valid") {
          // Limpiar sesión y redirigir
          sessi.clearSession();
          navigate("/");
          return [];
        }
      }
      const data = await response.json();
      setRoles(data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  // NUEVA FUNCIÓN: Consultar un acceso específico para edición
  const fetchAccessDetail = async (accessId) => {
    try {
      const response = await fetch(
        //`http://127.0.0.1:8000/api/Access/Consultar/?acceso_id=${accessId}`,
        `https://bei360.injupemp.gob.hn:8444/api/Access/Consultar/?acceso_id=${accessId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${sessi.sessionData.token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          const result = await response.json();
          if (result.code === "token_not_valid") {
            // Limpiar sesión y redirigir
            sessi.clearSession();
            navigate("/");
            return [];
          }
        }
        throw new Error("Error al cargar detalles del acceso");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching access detail:", error);
      throw error;
    }
  };

  const fetchUserData = async () => {
    try {
      const response = await fetch(
        //`http://127.0.0.1:8000/api/users/${userID}`,
        `https://bei360.injupemp.gob.hn:8444/api/users/${userID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          const result = await response.json();
          if (result.code === "token_not_valid") {
            // Limpiar sesión y redirigir
            sessi.clearSession();
            navigate("/");
            return [];
          }
        }
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      const normalizedDni = resolveUserDni(data);

      setUserData({
        ...data,
        dni: normalizedDni,
      });
      // Llenar el formulario con los datos actuales
      setUserFormData({
        first_name: data.first_name || "",
        last_name: data.last_name || "",
        email: data.email || "",
        username: data.username || "",
        departamento:
          data.departamento || data.Departamento || data.department || "",
        is_active: data.is_active,
        oficina: data.oficina,
        supervisor: normalizeSupervisorValue(data.supervisor),
        dni: normalizedDni,
      });
      return data;
    } catch (error) {
      console.error("Error fetching user data:", error);
      setError(`Error al cargar datos del usuario: ${error.message}`);
      return null;
    }
  };

  const fetchUserAccess = async () => {
    try {
      const response = await fetch(
        //`http://127.0.0.1:8000/api/Access/user/list/?UserId=${userID}`,
        `https://bei360.injupemp.gob.hn:8444/api/Access/user/list/?UserId=${userID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          const result = await response.json();
          if (result.code === "token_not_valid") {
            // Limpiar sesión y redirigir
            sessi.clearSession();
            navigate("/");
            return [];
          }
        }
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      setUserAccess(data);
    } catch (error) {
      console.error("Error fetching user access:", error);
      setError(`Error al cargar accesos del usuario: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // NUEVA FUNCIÓN: Eliminar acceso
  const handleDeleteAccess = async () => {
    try {
      if (!accessToDelete) return;

      const response = await fetch(
        //"http://127.0.0.1:8000/api/Access/Eliminar/",
        `https://bei360.injupemp.gob.hn:8444/api/Access/Eliminar/`,

        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
          body: JSON.stringify({
            acceso_id: accessToDelete.id,
          }),
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          const result = await response.json();
          if (result.code === "token_not_valid") {
            // Limpiar sesión y redirigir
            sessi.clearSession();
            navigate("/");
            return [];
          }
        }
        throw new Error("Error al eliminar el acceso");
      }

      setSnackbar({
        open: true,
        message: "Acceso eliminado exitosamente",
        severity: "success",
      });

      setDeleteModalOpen(false);
      setAccessToDelete(null);
      fetchUserAccess(); // Recargar la lista
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleEditUserClick = async () => {
    const data = await fetchUserData();
    if (data) {
      setEditUserModalOpen(true);
    }
  };

  const handleUserFormChange = (field, value) => {
    if (field === "dni") {
      value = String(value || "")
        .replace(/\D/g, "")
        .slice(0, 13);
    }
    setUserFormData((prev) => {
      const next = {
        ...prev,
        [field]: value,
      };

      if (field === "supervisor" && value && !next.dni) {
        next.dni = resolveUserDni(userData);
      }

      return next;
    });
  };

  const handleUpdateUser = async () => {
    try {
      const cleanedDni = String(userFormData.dni || "").replace(/\D/g, "");

      if (
        userFormData.supervisor &&
        !isSupervisorDepartment(userFormData.departamento)
      ) {
        setSnackbar({
          open: true,
          message:
            "Si el usuario es supervisor, el departamento debe ser Departamento de Control de Ingresos o Departamento Prestamos.",
          severity: "error",
        });
        return;
      }

      if (userFormData.supervisor && cleanedDni.length !== 13) {
        setSnackbar({
          open: true,
          message:
            "El DNI del usuario es obligatorio y debe tener 13 dígitos cuando es supervisor.",
          severity: "error",
        });
        return;
      }

      const formData = new FormData();
      formData.append("first_name", userFormData.first_name);
      formData.append("last_name", userFormData.last_name);
      formData.append("email", userFormData.email);
      formData.append("username", userFormData.username);
      formData.append("departamento", userFormData.departamento);
      formData.append("is_active", userFormData.is_active);
      formData.append("oficina", userFormData.oficina);
      formData.append("supervisor", userFormData.supervisor ? 1 : 0);
      formData.append("dni", cleanedDni);

      const response = await fetch(
        //`http://127.0.0.1:8000/api/users/${userID}/`,
        `https://bei360.injupemp.gob.hn:8444/api/users/${userID}/`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${sessi.sessionData.token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          const result = await response.json();
          if (result.code === "token_not_valid") {
            // Limpiar sesión y redirigir
            sessi.clearSession();
            navigate("/");
            return [];
          }
        }
        throw new Error("Error al actualizar el usuario");
      }

      setSnackbar({
        open: true,
        message: "Usuario actualizado exitosamente",
        severity: "success",
      });

      setEditUserModalOpen(false);
      fetchUserData(); // Recargar datos del usuario
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  // // FUNCIÓN MEJORADA: Para editar acceso
  // const handleEditClick = (access) => {
  //   setSelectedAccess(access);
  //   setFormData({
  //     modulo: access.modulo_id || access.modulo,
  //     rol: access.rol_id || access.rol,
  //     usuario_registro: sessi.sessionData.id,
  //   });
  //   fetchRoles(access.modulo_id || access.modulo);
  //   setEditModalOpen(true);
  // };

  // FUNCIÓN MEJORADA: Para editar acceso
  const handleEditClick = async (access) => {
    try {
      setLoading(true);
      // Cargar detalles completos del acceso
      const accessDetail = await fetchAccessDetail(access.id);

      setSelectedAccess(access);
      setFormData({
        modulo: accessDetail.data.modulo,
        rol: accessDetail.data.rol,
        usuario_registro: sessi.sessionData.id,
      });

      // Cargar roles para el módulo seleccionado
      await fetchRoles(accessDetail.data.modulo);
      setEditModalOpen(true);
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Error al cargar detalles del acceso",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // NUEVA FUNCIÓN: Para eliminar acceso (abrir modal de confirmación)
  const handleDeleteClick = (access) => {
    setAccessToDelete(access);
    setDeleteModalOpen(true);
  };

  const handleAddClick = () => {
    setSelectedAccess(null);
    setFormData({
      modulo: "",
      rol: "",
      usuario_registro: "",
    });
    setRoles([]);
    setAddModalOpen(true);
  };

  const handleModuleChange = (event) => {
    const moduleId = event.target.value;
    setFormData({ ...formData, modulo: moduleId, rol: "" });
    if (moduleId) {
      fetchRoles(moduleId);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      // const url = selectedAccess
      //   ? `http://127.0.0.1:8000/api/Access/Actualizar/`
      //   : "http://127.0.0.1:8000/api/Access/Registrar/";
      const url = selectedAccess
        ? "https://bei360.injupemp.gob.hn:8444/api/Access/Actualizar/"
        : "https://bei360.injupemp.gob.hn:8444/api/Access/Registrar/";

      const method = selectedAccess ? "PATCH" : "POST";
      let payload;

      if (selectedAccess) {
        // CORRECCIÓN: selectedAccess es un objeto, no un string
        payload = {
          acceso: selectedAccess.id, // ID del acceso a actualizar
          modulo: formData.modulo,
          rol: formData.rol,
          usuario_registro: sessi.sessionData.id || 1, // valor por defecto si no existe
        };
      } else {
        payload = {
          usuario: userID, // ID del usuario
          modulo: formData.modulo,
          rol: formData.rol,
          usuario_registro: sessi.sessionData.id || 1, // valor por defecto si no existe
        };
      }

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessi.sessionData.token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        if (response.status === 401) {
          const result = await response.json();
          if (result.code === "token_not_valid") {
            // Limpiar sesión y redirigir
            sessi.clearSession();
            navigate("/");
            return [];
          }
        }
        throw new Error("Error al guardar el acceso");
      }

      setSnackbar({
        open: true,
        message: selectedAccess
          ? "Acceso actualizado exitosamente"
          : "Acceso registrado exitosamente",
        severity: "success",
      });

      setEditModalOpen(false);
      setAddModalOpen(false);
      fetchUserAccess(); // Recargar la lista
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleCloseModal = () => {
    setEditModalOpen(false);
    setAddModalOpen(false);
    setEditUserModalOpen(false);
    setDeleteModalOpen(false);
    setAccessToDelete(null);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          Cargando información del usuario...
        </Typography>
      </Box>
    );
  }

  const paginatedAccess = userAccess.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const invalidSupervisorDepartment =
    userFormData.supervisor &&
    !isSupervisorDepartment(userFormData.departamento);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header con botones de acción */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1">
          Perfil de Usuario
        </Typography>
        <Box>
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={handleEditUserClick}
            sx={{ mr: 2 }}
          >
            Editar Usuario
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
          >
            Agregar Acceso
          </Button>
        </Box>
      </Box>

      {/* Información del usuario */}
      {userData && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    src={userData.photo}
                    sx={{ width: 120, height: 120, mb: 2 }}
                  />
                  <Chip
                    label={userData.is_active ? "ACTIVO" : "INACTIVO"}
                    color={userData.is_active ? "success" : "error"}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography variant="h5" gutterBottom>
                  {userData.first_name} {userData.last_name}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      Username: {userData.username}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      Email: {userData.email}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      Departamento: {userData.departamento}
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <Typography variant="body2">ID: {userData.id}</Typography>
                  </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}

      {/* Lista de accesos con columna de acciones */}
      <Card>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6">Accesos del Usuario</Typography>
            <Chip label={`${userAccess.length} acceso(s)`} color="primary" />
          </Box>
          <Divider sx={{ mb: 2 }} />

          {userAccess.length === 0 ? (
            <Alert severity="info">
              Este usuario no tiene accesos asignados
            </Alert>
          ) : (
            <>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "primary.main" }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Módulo
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Rol
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Acciones
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedAccess.map((acceso) => (
                      <TableRow key={acceso.id} hover>
                        <TableCell>
                          <Typography fontWeight="medium">
                            {acceso.modulo}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={acceso.rol}
                            color="secondary"
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color="primary"
                            onClick={() => handleEditClick(acceso)}
                            sx={{ mr: 1 }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteClick(acceso)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={userAccess.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          )}
        </CardContent>
      </Card>

      {/* Modal para Editar/Agregar Acceso */}
      <Dialog
        open={editModalOpen || addModalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {selectedAccess ? "Editar Acceso" : "Agregar Nuevo Acceso"}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Módulo"
                  value={formData.modulo}
                  onChange={handleModuleChange}
                  required
                >
                  <MenuItem value="">Seleccionar módulo</MenuItem>
                  {modules.map((module) => (
                    <MenuItem key={module.id} value={module.id}>
                      {module.modulo}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Rol"
                  value={formData.rol}
                  onChange={(e) =>
                    setFormData({ ...formData, rol: e.target.value })
                  }
                  required
                  disabled={!formData.modulo}
                >
                  <MenuItem value="">Seleccionar rol</MenuItem>
                  {roles.map((role) => (
                    <MenuItem key={role.id} value={role.id}>
                      {role.rol}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancelar</Button>
            <Button type="submit" variant="contained">
              {selectedAccess ? "Actualizar" : "Registrar"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Modal para Eliminar Acceso */}
      <Dialog open={deleteModalOpen} onClose={handleCloseModal}>
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro de que deseas eliminar el acceso a{" "}
            <strong>{accessToDelete?.modulo}</strong> con el rol{" "}
            <strong>{accessToDelete?.rol}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancelar</Button>
          <Button
            onClick={handleDeleteAccess}
            variant="contained"
            color="error"
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal para Editar Usuario */}
      <Dialog
        open={editUserModalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Editar Información del Usuario</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nombre"
                value={userFormData.first_name}
                onChange={(e) =>
                  handleUserFormChange("first_name", e.target.value)
                }
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Apellido"
                value={userFormData.last_name}
                onChange={(e) =>
                  handleUserFormChange("last_name", e.target.value)
                }
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={userFormData.email}
                onChange={(e) => handleUserFormChange("email", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Username"
                value={userFormData.username}
                onChange={(e) =>
                  handleUserFormChange("username", e.target.value)
                }
                required
              />
            </Grid>
            <Grid item xs={12}>
              {/* <TextField
                fullWidth
                label="Departamento"
                value={userFormData.departamento}
                onChange={(e) =>
                  handleUserFormChange("departamento", e.target.value)
                }
              /> */}

              <TextField
                select
                label="Departamento"
                name="departamento"
                fullWidth
                margin="normal"
                value={userFormData.departamento}
                onChange={(e) =>
                  handleUserFormChange("departamento", e.target.value)
                }
                required
                error={invalidSupervisorDepartment}
                helperText={
                  userFormData.supervisor
                    ? "Para supervisor solo se permiten Departamento de Control de Ingresos y Departamento Prestamos."
                    : ""
                }
                inputProps={{ style: { textTransform: "uppercase" } }}
              >
                {DEPARTAMENTO_CHOICES.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    disabled={
                      userFormData.supervisor &&
                      !SUPERVISOR_ALLOWED_DEPARTMENTS.includes(option.value)
                    }
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                label="Oficina"
                name="oficina"
                fullWidth
                margin="normal"
                value={userFormData.oficina}
                onChange={(e) =>
                  handleUserFormChange("oficina", e.target.value)
                }
                required
                inputProps={{ style: { textTransform: "uppercase" } }}
              >
                <MenuItem value="">Seleccionar Oficina</MenuItem>
                {oficinas.map((oficina) => (
                  <MenuItem key={oficina.OficinaId} value={oficina.OficinaId}>
                    {oficina.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: "grid", rowGap: 1 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={userFormData.is_active}
                          onChange={(e) =>
                            handleUserFormChange("is_active", e.target.checked)
                          }
                          color="primary"
                        />
                      }
                      label="Usuario Activo"
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={userFormData.supervisor}
                          onChange={(e) =>
                            handleUserFormChange("supervisor", e.target.checked)
                          }
                          color="primary"
                        />
                      }
                      label="Supervisor de usuarios"
                    />
                  </Box>
                </Grid>

                {userFormData.supervisor && (
                  <Grid item xs={12} md={8}>
                    <Box sx={{ display: "grid", rowGap: 0.8 }}>
                      <TextField
                        fullWidth
                        label="DNI de usuario"
                        value={userFormData.dni}
                        onChange={(e) =>
                          handleUserFormChange("dni", e.target.value)
                        }
                        required
                        inputProps={{ maxLength: 13, inputMode: "numeric" }}
                        helperText="Ingrese el DNI de 13 dígitos."
                      />
                      <Typography variant="caption" color="text.secondary">
                        Al activar supervisor, el DNI del usuario se utiliza
                        para los flujos que consultan supervisores.
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancelar</Button>
          <Button
            onClick={handleUpdateUser}
            variant="contained"
            startIcon={<SaveIcon />}
          >
            Guardar Cambios
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modales y snackbar existentes... */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbar.message}
      />
    </Box>
  );
};

export default UserProfile;
